// The time zones as a picker's source (ADR-080 §3 — the CODE kind): straight from
// Intl — there is no `timezones` table (ADR-030: zones are plain strings, Intl owns
// the catalogue). Each row is the zone with its offset now ("Asia/Riyadh
// (UTC+03:00)"), built ONCE per page life — a few hundred `Intl` calls, never on a
// render — and shared by every field that picks a zone.
//
// `UTC` is prepended because `supportedValuesOf` omits it (along with `Etc/UTC` and
// `GMT`) even though Intl accepts it everywhere — and for a project spanning several
// countries it is often the honest answer. The backend does NOT validate against
// this list (it asks Intl whether the zone is acceptable), so a zone missing here is
// still a valid value: a HELD one stays a row (an edit always shows what it holds) —
// and so does a zone a country gives, since the runtime lists some zones under their
// OLD names (`Asia/Calcutta` for the `Asia/Kolkata` a country carries).

import { timezoneLabel } from '../lib/format.js';
import { codeSource, type CodeSource, type OptionRow } from './useOptions.js';

let zoneRows: OptionRow[] | null = null;
const allZones = (): OptionRow[] =>
  (zoneRows ??= ['UTC', ...Intl.supportedValuesOf('timeZone')].map((zone) => ({ id: zone, label: timezoneLabel(zone), pickable: true, group: null })));

/** Every zone the runtime knows — plus each of `held` the runtime does not list (the value a field holds · the zones
 *  its countries give). Build it once per held set. */
export function timezoneSource(held: readonly (string | null | undefined)[]): CodeSource {
  const rows = allZones();
  const known = new Set(rows.map((r) => r.id));
  const extra = [...new Set(held.filter((z): z is string => !!z && !known.has(z)))];
  if (extra.length === 0) return codeSource('timezones', rows);
  return codeSource(`timezones:${extra.join(',')}`, [...rows, ...extra.map((zone) => ({ id: zone, label: timezoneLabel(zone), pickable: true, group: null }))]);
}
